import { ACCESS_DENIED } from '@constants/cp-paths.js';
import { cpBaseUrl, DELETE, GET, POST, PUT } from '@constants/generic-constants.js';
import { ACTION_INDEX, PERMISSION_KEY_ADMIN, PERMISSION_KEY_ROLE } from '@constants/permission-constants.js';
import { redirectToPath } from '@utils/utils.js';
import PermissionsHelper from 'auth/helper/PermissionHelper.js';
import NetworkManager from '../../services/network-service.js';

export const googleLoginApi = (payload) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/auth/google_login`;

    NetworkManager.performRequest(url, payload, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const logoutApi = () => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/auth/logout`;

    NetworkManager.performRequest(url, null, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCurrentUserApi = () => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/admins/current`;

    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCurrentRoles = (params) => {
  if (!PermissionsHelper.getPermissions(PERMISSION_KEY_ROLE, ACTION_INDEX)) {
    redirectToPath(ACCESS_DENIED);
    return;
  }
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/roles${params}`;

    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getUsersList = (params) => {
  if (!PermissionsHelper.getPermissions(PERMISSION_KEY_ADMIN, ACTION_INDEX)) {
    redirectToPath(ACCESS_DENIED);
    return;
  }
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/admins${params}`;

    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getPermissions = (param) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/permissions/grouped${param}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateRoles = (param, body) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/roles${param}`;

    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const addRoles = (body) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/roles`;

    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const updateUserRole = (adminID, body) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/admins/${adminID}/assign_role`;

    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createUser = (body) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/admins`;

    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateUser = (id, body) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/admins/${id}`;

    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteRole = (roleID) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/roles${roleID}`;

    NetworkManager.performRequest(url, null, DELETE)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getUserQrInfo = () => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/admins/prop_go_qr_info`;

    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
